const internetSpeedEnum = Object.freeze({
  KBPS: 0,
  MBPS: 1,
  GBPS: 2,
})

export default internetSpeedEnum
